import Materialize from "materialize-css";

export default class AsdHistory {

    static init() {
        let el = document.getElementById('asd-history-toggler');

        if (el) {
            window.AsdHistoryMode = new AsdHistory(el);
        }
    }

    constructor( trigger ) {

        if (!trigger) {
            return;
        }
        this.trigger = trigger;

        if (!window.AsdHistorySettings) {
            console.log('No suitable history mode in this page. Deleting trigger.');
            this.deleteTrigger();
            return;
        } else {
            this.entity_id = window.AsdHistorySettings.entity_id;
            this.entity_type = window.AsdHistorySettings.entity_type;
        }

        this.elements = document.querySelectorAll('.history-capable-data');
        this.button = this.trigger.querySelector('a.btn');
        this.button.addEventListener('click', this.bindsDataEvents.bind(this) );

        this.baseUrl = '/index.php?option=com_api&app=asdgest&resource=auditlog';

        console.log('History mode ready');
    }

    bindsDataEvents() {
        this.elements.forEach( x => {
            x.addEventListener('click', this.openHistory.bind(this), false );
            x.classList.add('cursorPointer');
        });
        alert('Modalità cronologia attivata. Cliccare sul campo di interesse');
    }

    openHistory(event) {
        if (event.currentTarget !== event.target) {
            return;
        }
        let field = event.target.getAttribute('data-field');
        let params = 'entity_id='+this.entity_id+'&entity_type='+this.entity_type+'&field='+field;

        window.axios.get( this.baseUrl+'&'+params,{})
            .then( response => {
                if (response.data.hasOwnProperty('exception')) {
                    alert('Problema interno. Contattare admin@ucis.org');
                    return;
                }
                try {
                    this.showResults(field, response.data.data, event.target);
                }
                catch( error ) {
                    console.log(error);
                    alert('Errore nel visualizzare i risultati. Contattare admin@ucis.org');
                }
            })
            .catch( response => {
                console.log(response);
            });
    }

    restoreData(event) {

        let field = event.target.getAttribute('data-field');
        let value = event.target.getAttribute('data-value');

        let yes = confirm('Stai per ripristinare il dato `'+field+'` con il valore "'+value+'"');

        if (!yes) {
            console.log('Restore aborted');
            alert('Ripristino annullato');
            return;
        }

        let formData = new FormData;

        formData.append('entity_id',this.entity_id);
        formData.append('entity_type',this.entity_type);
        formData.append('field',field);
        formData.append('value',value);

        window.axios({
            url: this.baseUrl,
            method: 'POST',
            data: formData,
            config: {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }
        })
            .then( response => {
                if (response.data.ok === true) {
                    alert('Modifica effettuata, ricaricare la pagina')
                } else {
                    alert('Modifica non riuscita: '+response.data.message);
                }
            })
            .catch( error => {
                alert('Modifica non riuscita. Contatta admin@ucis.org');
                console.log(error);
            });
    }

    showResults(field, results, container) {

        let html = this.createTableHeader();
        results.forEach(result => {
            html += this.createHtmlRow(result);
        })
        html += '</table>';

        // Detailed list of modifications
        let tooltip = this.createTooltip(html);

        // Dropdown to restore data
        let dropdown = this.createDropDown(results, field);
        dropdown.id = 'dropdown_'+field;

        // Button with icon inside
        let button = this.createHistoryButton(field);

        // Insert in DOM
        button.appendChild(tooltip);
        container.appendChild(button);
        container.appendChild(dropdown);

        // Init materialize components
        Materialize.Tooltip.init(tooltip);
        Materialize.Dropdown.init(button, {
            constrainWidth: false,
        });

    }

    createTableHeader() {
        let html = '';

        html += '<table>';

        html += '<tr>' +
            '<th>Data</th>' +
            '<th>Utente</th>' +
            '<th>Vecchio</th>' +
            '<th>Nuovo</th>' +
            '<th>Altre modifiche</th>' +
            '</tr>';

        return html;
    }

    createHtmlRow( data ) {

        let diff = JSON.parse(data.diff);

        let row = '<tr>';

        row += '<td>'+data.created_at+'</td>';
        row += '<td>'+data.name+'</td>';
        row += '<td>'+diff.old+'</td>';
        row += '<td>'+diff.new+'</td>';
        row += '<td>'+data.other_diff+'</td>';

        row += '</tr>';

        return row;
    }

    createDropDown( results, field ) {
        let dw = document.createElement('ul');
        dw.classList.add('dropdown-content');
        results.forEach( result => {
            let element = this.createDropDownElement(result, field);
            dw.appendChild(element);
        });
        return dw;
    }

    createDropDownElement( data, field ) {

        let diff = JSON.parse(data.diff);
        let row = document.createElement('li');

        let writings = document.createElement('a');
        writings.innerText = 'Ripristina "'+diff.old+'"';

        row.appendChild(writings);

        writings.setAttribute('data-field', field);
        writings.setAttribute('data-value', diff.old);

        writings.addEventListener('click',this.restoreData.bind(this) );

        return row;
    }

    createHistoryButton(field) {
        let button = document.createElement('a');
        button.classList.add('dropdown-trigger');
        button.classList.add('btn');
        button.setAttribute('data-target','dropdown_'+field);

        return button;
    }

    createTooltip(html) {
        let container = document.createElement('i');
        container.classList.add('material-icons');
        container.innerHTML = 'history';

        container.classList.add('tooltipped');
        container.setAttribute('data-tooltip',html)
        container.setAttribute('data-position','bottom')

        return container;
    }

    deleteTrigger() {
        this.trigger.parentElement.removeChild(this.trigger);
    }


}
